import { motion, AnimatePresence } from "framer-motion";
import { useLocation } from "react-router-dom";
import { ReactNode, useLayoutEffect } from "react";
import { useIsMobile } from "@/hooks/use-mobile";

interface PageTransitionProps {
  children: ReactNode;
}

const PageTransition = ({ children }: PageTransitionProps) => {
  const location = useLocation();
  const isMobile = useIsMobile();

  // Reset scroll position on route change - use useLayoutEffect to run before paint
  useLayoutEffect(() => {
    // Force scroll to top immediately
    window.scrollTo({ top: 0, left: 0, behavior: "instant" as ScrollBehavior });
    // Also reset document body scroll in case of any issues
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }, [location.pathname]);

  // Faster, simpler transitions on mobile
  const enterDuration = isMobile ? 0.2 : 0.3;
  const exitDuration = isMobile ? 0.15 : 0.2;

  return (
    <AnimatePresence mode="wait" initial={false}>
      <motion.div
        key={location.pathname}
        initial={{ opacity: 0 }}
        animate={{ 
          opacity: 1,
          transition: {
            duration: enterDuration,
            ease: "easeOut",
          }
        }}
        exit={{ 
          opacity: 0,
          transition: {
            duration: exitDuration,
            ease: "easeIn",
          }
        }}
        style={{ 
          minHeight: "100vh",
          willChange: isMobile ? "opacity" : undefined,
        }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
};

export default PageTransition;
